<div class="p-6">

  <!-- Header -->
  <div class="flex items-center justify-between mb-5">
    <div>
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Cola de Eventos</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        Eventos en cola del motor de workflows
        @if (totalElements > 0) {
          · {{ totalElements }} total
        }
      </p>
    </div>
    <div class="flex gap-2">
      <button (click)="loadQueue()" [disabled]="loading"
              class="inline-flex items-center gap-1.5 px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-40 transition-colors">
        <svg class="w-4 h-4" [class.animate-spin]="loading" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Actualizar
      </button>
      <button (click)="processPending()" [disabled]="processing || loading"
              class="inline-flex items-center gap-1.5 px-4 py-2 text-sm bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors">
        @if (processing) {
          <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          Procesando...
        } @else {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
          Procesar pendientes
        }
        @if (pendingCount > 0) {
          <span class="ml-1 bg-white/30 text-white text-xs px-1.5 rounded-full">{{ pendingCount }}</span>
        }
      </button>
    </div>
  </div>

  <!-- Mensajes -->
  <!-- El éxito va por ToastService (INC_CRM_020 (2) inc11). -->
  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span><button (click)="error = ''">&times;</button>
    </div>
  }

  <!-- Métricas rápidas -->
  @if (!loading && items.length > 0) {
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
      <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-3 text-center">
        <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ totalElements }}</p>
        <p class="text-xs text-gray-500 mt-0.5">Total</p>
      </div>
      <div class="bg-yellow-50 dark:bg-yellow-900/20 rounded-xl border border-yellow-200 dark:border-yellow-800 p-3 text-center">
        <p class="text-2xl font-bold text-yellow-700">{{ pendingCount }}</p>
        <p class="text-xs text-yellow-600 mt-0.5">Pendientes</p>
      </div>
      <div class="bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-800 p-3 text-center">
        <p class="text-2xl font-bold text-red-700">{{ failedCount }}</p>
        <p class="text-xs text-red-600 mt-0.5">Fallidos</p>
      </div>
      <div class="bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 p-3 text-center">
        <p class="text-2xl font-bold text-green-700">
          {{ items.length - pendingCount - failedCount }}
        </p>
        <p class="text-xs text-green-600 mt-0.5">Completados/Otros</p>
      </div>
    </div>
  }

  <!-- Filtros -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-4 mb-4">
    <div class="flex flex-wrap gap-3">
      <select [(ngModel)]="filterStatus" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (s of statusOptions; track s.value) {
          <option [value]="s.value">{{ s.label }}</option>
        }
      </select>
      <select [(ngModel)]="filterQueueType" (ngModelChange)="onFilterChange()"
              class="px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
        @for (t of queueTypeOptions; track t.value) {
          <option [value]="t.value">{{ t.label }}</option>
        }
      </select>
      @if (filterStatus || filterQueueType) {
        <button (click)="filterStatus = ''; filterQueueType = ''; onFilterChange()"
                class="px-3 py-2 text-sm text-gray-500 border border-gray-200 rounded-lg hover:bg-gray-50">
          Limpiar
        </button>
      }
    </div>
  </div>

  <!-- Tabla -->
  <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 overflow-hidden">
    @if (loading) {
      <div class="flex justify-center py-12 text-gray-400">
        <svg class="animate-spin w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
        </svg>
        Cargando cola...
      </div>
    } @else if (items.length === 0) {
      <div class="flex flex-col items-center justify-center py-14 text-gray-400">
        <svg class="w-12 h-12 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
        </svg>
        <p class="text-base font-medium text-gray-500 dark:text-gray-400">Cola vacía</p>
        <p class="text-sm text-gray-400 mt-1">No hay items en cola con los filtros actuales.</p>
      </div>
    } @else {
      <div class="overflow-x-auto">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">ID</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Tipo</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Estado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Evento</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Objeto</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Origen</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Disponible</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Intentos</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Procesado</th>
              <th class="text-left px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Error</th>
              <th class="text-right px-4 py-3 font-medium text-gray-600 dark:text-gray-400">Payload</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            @for (item of items; track item.id) {
              <tr class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
                <td class="px-4 py-3 font-mono text-xs text-gray-500">#{{ item.id }}</td>
                <td class="px-4 py-3">
                  <span class="text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 px-1.5 py-0.5 rounded"
                        [title]="item.queueType">
                    {{ getQueueTypeLabel(item.queueType) }}
                  </span>
                </td>
                <td class="px-4 py-3">
                  <span class="inline-flex px-2 py-0.5 rounded-full text-xs font-medium"
                        [ngClass]="getStatusClass(item.status)">
                    {{ getStatusLabel(item.status) }}
                  </span>
                </td>
                <!--
                  INC_CRM_020 (6) inc16 — la tabla mostraba «CONTACT_CREATED» y «CONTACT #55».
                  Ahora manda la etiqueta en español y el nombre del registro; la clave técnica y
                  el id quedan como línea secundaria y en el `title`, que es lo que se necesita
                  para depurar sin sacrificar la legibilidad.
                -->
                <td class="px-4 py-3 text-xs text-gray-700 dark:text-gray-300">
                  @if (item.eventLabel) {
                    <span [title]="item.eventType ?? ''">{{ item.eventLabel }}</span>
                  } @else {
                    {{ item.eventType || '—' }}
                  }
                </td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  @if (item.objectType) {
                    <div class="flex flex-col">
                      <span class="text-gray-800 dark:text-gray-200">
                        {{ item.objectName || item.objectTypeLabel || objectTypeText(item.objectType) }}
                      </span>
                      <span class="text-[11px] text-gray-400">
                        {{ item.objectTypeLabel || objectTypeText(item.objectType) }} · #{{ item.objectId }}
                      </span>
                    </div>
                  } @else { — }
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  <span [title]="item.sourceKey ?? ''">{{ getSourceModuleLabel(item.sourceModule) }}</span>
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  {{ item.availableAt | date:'dd/MM HH:mm' }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-600 dark:text-gray-400">
                  {{ item.attempts }}/{{ item.maxAttempts }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  {{ item.processedAt ? (item.processedAt | date:'dd/MM HH:mm') : '—' }}
                </td>
                <td class="px-4 py-3 max-w-32">
                  @if (item.lastError) {
                    <span class="text-xs text-red-500 truncate block" [title]="item.lastError">
                      {{ item.lastError | slice:0:30 }}{{ item.lastError.length > 30 ? '...' : '' }}
                    </span>
                  } @else { <span class="text-gray-300">—</span> }
                </td>
                <td class="px-4 py-3 text-right">
                  @if (item.payload && (item.payload | json) !== '{}') {
                    <button (click)="openPayload(item)"
                            class="text-xs text-blue-600 hover:text-blue-800 hover:underline">
                      Ver
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="px-4 py-3 border-t border-gray-100 dark:border-gray-700 text-xs text-gray-500">
        {{ items.length }} item(s) mostrado(s)
        @if (totalElements > items.length) { · {{ totalElements }} total }
      </div>
    }
  </div>
</div>

<!-- Modal: Payload -->
@if (showPayloadModal) {
  <div class="fixed inset-0 z-modal flex items-center justify-center bg-black/50">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg mx-4 flex flex-col max-h-[70vh]">
      <div class="flex items-center justify-between p-4 border-b border-gray-100 dark:border-gray-700">
        <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Payload del evento</h3>
        <button (click)="showPayloadModal = false" class="text-gray-400 hover:text-gray-600">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div class="overflow-y-auto flex-1 p-4">
        <pre class="text-xs font-mono text-gray-800 dark:text-gray-200 whitespace-pre-wrap">{{ payloadJson }}</pre>
      </div>
    </div>
  </div>
}
